<div class="emperor-ui-timeline">
  <ng-container *ngFor="let step of steps; let i = index">
    <emperor-timeline-step [step]="step" [order]="i"></emperor-timeline-step>
  </ng-container>
</div>
